
const SubmitterType = {
  INSTITUTION: 0,
  INSTITUTION_GROUP: 1
}

export {
  SubmitterType
}



// WEBPACK FOOTER //
// ./src/enums/SubmitterType.js